import { useState, useEffect } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { getCookie, clearAllAuthCookies } from "../utils/cookies"
import { LogOut, Bell, X, Home, Calendar, FileText, CreditCard, Users, User, Menu, LayoutDashboard, Package } from "lucide-react"
 
export function ProfileLayout({ children }) {
  const location = useLocation()
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [user, setUser] = useState(null)

  const handleLogout = () => {
    clearAllAuthCookies()
    localStorage.removeItem("user")
    sessionStorage.clear()
    window.dispatchEvent(new CustomEvent("user-updated", { detail: null }))
    setTimeout(() => {
      setSidebarOpen(false)
      navigate("/", { replace: true })
    }, 0)
  }
 
  useEffect(() => {
    const savedUser = getCookie("user")
    if (savedUser && savedUser !== "undefined") {
      try { setUser(JSON.parse(savedUser)) } catch (e) {}
    }
  }, [])
  
  const getInitials = (name) => {
    if (!name) return "U"
    const parts = name.split(" ")
    if (parts.length >= 2) {
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
    }
    return name.charAt(0).toUpperCase()
  }
 
  const menuItems = [
    { name: "Portal Dashboard", href: "/portal-dashboard", icon: LayoutDashboard },
    { name: "My Appointments", href: "/my-bookings", icon: Calendar },
    { name: "My Packages", href: "/my-packages", icon: Package },
    { name: "Lab Reports", href: "/my-reports", icon: FileText },
    { name: "Prescriptions", href: "/prescriptions", icon: FileText },
    { name: "Bills & Payments", href: "/bills-receipts", icon: CreditCard },
    { name: "Family Details", href: "/family-members", icon: Users },
    { name: "Logout", href: "#", icon: LogOut, action: handleLogout },
  ]
 
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="fixed top-0 w-full bg-white border-b shadow-sm py-1 z-[40]" >
        <div className="flex items-center justify-between h-22 px-8 mx-auto">
          <Link to="/">
            <img src="/images/pranaam-logo.png" alt="Pranaam Hospitals Logo" className="h-16 w-auto" />
          </Link>
          <div className="flex items-center gap-4">
            <button className="relative hidden xl:block">
              <Bell className="w-5 h-5 text-gray-600" />
            </button>
            <Link to="/profile" className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-red-600 font-semibold hover:bg-red-200 transition-colors">
              {user ? getInitials(user.name) : "U"}
            </Link>
            <button onClick={() => setSidebarOpen(!sidebarOpen)} className="xl:hidden p-2">
              <Menu className="w-6 h-6" />
            </button>
          </div>
        </div>
      </header>
     
      <div className="flex">
        {sidebarOpen && <div className="fixed inset-0 bg-black/50 z-[45] xl:hidden" onClick={() => setSidebarOpen(false)} />}
       
        <aside className={`fixed top-0 left-0 z-[50] h-screen w-full xl:w-64 xl:top-[75px] bg-white shadow-lg xl:shadow-none border-r transform transition-transform xl:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full xl:translate-x-0'}`}>
          <div className="flex flex-col h-full">
            <div className="flex items-center justify-between p-4 border-b xl:hidden">
              <Link to="/" onClick={() => setSidebarOpen(false)}>
                <img src="/images/pranaam-logo.png" alt="Logo" className="h-12" />
              </Link>
              <button onClick={() => setSidebarOpen(false)} className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200">
                <X className="w-5 h-5" />
              </button>
            </div>
           
            <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
              {menuItems.map((item) => {
                const isActive = location.pathname === item.href
                const Icon = item.icon
               
                if (item.action) {
                  return (
                    <button key={item.name} onClick={item.action}
                      className="w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors text-black hover:bg-gray-200">
                      <Icon className="w-5 h-5" />
                      <span>{item.name}</span>
                    </button>
                  )
                }
               
                return (
                  <Link key={item.name} to={item.href} onClick={() => setSidebarOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive ? "bg-black text-white" : "text-black hover:bg-gray-200"}`}>
                    <Icon className="w-5 h-5" />
                    <span>{item.name}</span>
                  </Link>
                )
              })}
            </nav>
           
            <div className="p-4 border-t space-y-2">
              {/* <div className="flex items-center gap-3 px-4 py-2">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                  <User className="w-5 h-5 text-blue-600" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium">{user?.name || "User"}</p>
                  <p className="text-xs text-gray-500">ID: {user?.patientId || "P001234"}</p>
                </div>
              </div> */}
              {/* <button className="w-full bg-red-600 text-white py-2 rounded-lg text-sm font-medium">Emergency</button>
              <button onClick={onLogout} className="w-full border border-gray-300 py-2 rounded-lg text-sm font-medium">Support</button> */}
            </div>
          </div>
        </aside>
       
        <main className="flex-1 xl:ml-[16rem] py-[75px] min-w-0 overflow-x-hidden">{children}</main>
      </div>
    </div>
  )
}